import numeral from 'numeral';
import { FormattersTypes } from '@/services/types/formatter'
import { FORMATS } from '@/services/constants/format'

export default ({ vtag, component, data, key, decimal = 2 }: FormattersTypes) => {

  component.tag = 'span';

  const val = data[key] || 0;
  const value = numeral(val).format(FORMATS[decimal]);

  return vtag('div', {class: {
        'class-name': true,
        ...(key == 'reports-roi' && val < 0 ? {'class-name-red': true}: { }),
        ...(key == 'reports-roi' && val > 0 ? {'class-name-green': true}: { })
      }},
    [vtag('span', {class: {'percent': true}}, [value, '%'])])
}
